import React, { FC } from 'react';

import { Illustration, IllustrationProps } from '../IllustrationWrapper';

export const OnePerson: FC<IllustrationProps> = ({ size, color }) => (
  <Illustration size={size} color={color}>
    <path d="M54 47V71C54 72.1 53.1 73 52 73C50.9 73 50 72.1 50 71V47C50 41.49 45.51 37 40 37C34.49 37 30 41.49 30 47V71C30 72.1 29.1 73 28 73C26.9 73 26 72.1 26 71V47C26 39.28 32.28 33 40 33C47.72 33 54 39.28 54 47ZM29 18C29 11.92 33.92 7 40 7C46.08 7 51 11.92 51 18C51 24.08 46.08 29 40 29C33.92 29 29 24.08 29 18ZM33 18C33 21.86 36.14 25 40 25C43.86 25 47 21.86 47 18C47 14.14 43.86 11 40 11C36.14 11 33 14.14 33 18Z" />
  </Illustration>
);
